import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface InitialStateProps {
  searchTechSkills: string;
  paginationTechSkills: number;
}

export const initialState: InitialStateProps = {
  searchTechSkills: "",
  paginationTechSkills: 0,
};

export const TechSkillSlice = createSlice({
  name: "TechSkills",
  initialState,
  reducers: {
    setSearchTechSkills: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchTechSkills = action.payload;
    },
    setPaginationTechSkills: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.paginationTechSkills = action.payload;
    },
    resetTechSkillState: () => initialState,
  },
});

export const {
  setSearchTechSkills,
  setPaginationTechSkills,
  resetTechSkillState,
} = TechSkillSlice.actions;
export default TechSkillSlice.reducer;
